"use client";

import FooterBrand from "./footer/FooterBrand";
import FooterLinks from "./footer/FooterLinks";
import FooterContact from "./footer/FooterContact";
import FooterInfo from "./footer/FooterInfo";
import FooterBottom from "./footer/FooterBottom";

export default function Footer() {
  return (
    <footer className="bg-black text-white w-full font-body">
      {/* Main Footer Content */}
      <div className="w-full px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div>
            <FooterBrand />
          </div>

          {/* Links Section */}
          <div>
            <FooterLinks />
          </div>

          {/* Hours & Areas */}
          <div>
            <FooterInfo />
          </div>

          {/* Contact Section */}
          <div>
            <FooterContact />
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <FooterBottom />
      </div>
    </footer>
  );
}